import React, { useState, useEffect } from "react";
import { GoogleMap, HeatmapLayer } from "@react-google-maps/api";
import { Card } from "react-bootstrap";

const InstalledKitsLocationChart = ({ title, data = [] }) => {
  const mapContainerStyle = {
    width: "100%",
    height: "600px",
  };

  const center = { lat: data[0]?.lat ?? 51.5074, lng: data[0]?.lng ?? -0.1278 };

  const [heatmapData, setHeatmapData] = useState([]);

  useEffect(() => {
    if (window.google && window.google.maps && data.length > 0) {
      setHeatmapData(
        data.map((state) => ({
          location: new window.google.maps.LatLng(state.lat, state.lng),
        }))
      );
    } else {
      console.error("Google Maps API not loaded properly");
    }
  }, [data]);

  const isValid = data?.length > 0;
  const mapOptions = {
    // 🔹 Prevent infinite horizontal scrolling
    restriction: {
      latLngBounds: {
        north: 85,
        south: -85,
        west: -179.99,
        east: 179.99,
      },
      strictBounds: true,
    },

    gestureHandling: "greedy",
  };

  return (
    <Card className="dashboard_cards h-100" style={{ border: "none" }}>
      <Card.Body
        className={`d-flex flex-column ${
          isValid ? "p-0 row-gap-0" : "row-gap-3"
        }`}
      >
        <div style={{ padding: isValid ? "20px" : "0px" }}>
          <Card.Title className="text_gray m-0">{title}</Card.Title>
          <span className="text_gray">Past 60 Days</span>
        </div>
        {isValid ? (
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={center}
            zoom={5}
            options={{
              ...mapOptions,
            }}
          >
            {heatmapData.length > 0 && (
              <HeatmapLayer
                data={heatmapData.map((point) => point.location)}
                options={{
                  radius: 40,
                  opacity: 0.8,
                }}
              />
            )}
          </GoogleMap>
        ) : (
          <h5 className="m-0">No data found</h5>
        )}
      </Card.Body>
    </Card>
  );
};

export default InstalledKitsLocationChart;
